import {newValidator, validateNotBlank } from 'simple-valley'

export default function presignValidator(presigning){
  let v = newValidator(presigning)
  v = validateNotBlank(v, ['fileType', 'fileName', 'fileSize'])

  return v
}
